<template>
    <div style="max-width: 600px; margin: auto; text-align: left;">
        <FieldHeader v-if="showHeader && !showBlockCheck" :field="field" />

        <q-checkbox
            v-if="showBlockCheck"
            :model-value="blockChecked"
            :disable="readOnly"
            @update:model-value="onBlockUpdate"
        >
            <FieldHeader v-if="showHeader" :field="field" />
        </q-checkbox>

        <div v-for="(item, index) in checklistItems" :key="`checklist-item-${index}`" class="q-ml-md">
            <q-checkbox
                :model-value="itemChecked(index)"
                :disable="readOnly"
                :label="item"
                @update:model-value="(checked) => onItemUpdate(index, checked)"
            />
        </div>
    </div>
</template>

<script>
    import FieldHeader from './FieldHeader.vue';

    export default {
        name: 'ChecklistField',
        components: { FieldHeader },
        props: {
            field: {
                type: Object,
                required: true,
            },
            modelValue: {
                type: [Object, String],
                default: () => ({}),
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['update:modelValue', 'blur'],
        computed: {
            checklistItems() {
                const items = this.field?.options?.items;
                if (!Array.isArray(items)) return [];
                return items.filter((item) => typeof item === 'string').map((item) => item.trim()).filter(Boolean);
            },
            showBlockCheck() {
                if (this.checklistItems.length === 0) return true;
                return this.field?.options?.block !== false;
            },
            blockChecked() {
                const value = this.normalizedValue();
                if (this.checklistItems.length > 0 && this.showBlockCheck) {
                    return this.ensureItemChecks(value).every(Boolean);
                }
                return Boolean(value.block);
            },
        },
        methods: {
            normalizedValue() {
                const source = (this.modelValue && typeof this.modelValue === 'object' && !Array.isArray(this.modelValue))
                    ? this.modelValue
                    : {};

                return {
                    block: Boolean(source.block),
                    items: this.ensureItemChecks(source),
                };
            },
            ensureItemChecks(source) {
                const existingItems = Array.isArray(source?.items) ? source.items : [];
                return this.checklistItems.map((_, index) => Boolean(existingItems[index]));
            },
            emitValue(nextValue) {
                this.$emit('update:modelValue', nextValue);
                this.$emit('blur');
            },
            itemChecked(index) {
                const value = this.normalizedValue();
                return Boolean(value.items[index]);
            },
            onBlockUpdate(checked) {
                const nextChecked = Boolean(checked);
                const value = this.normalizedValue();

                if (this.checklistItems.length === 0) {
                    this.emitValue({ block: nextChecked, items: [] });
                    return;
                }

                const nextItems = this.ensureItemChecks(value).map(() => nextChecked);
                this.emitValue({ block: nextChecked, items: nextItems });
            },
            onItemUpdate(index, checked) {
                const value = this.normalizedValue();
                const nextItems = this.ensureItemChecks(value);
                nextItems[index] = Boolean(checked);

                const nextBlock = this.showBlockCheck ? nextItems.every(Boolean) : Boolean(value.block);
                this.emitValue({ block: nextBlock, items: nextItems });
            },
        },
    };
</script>